const NotificationsErrors = {
  noNotifications: 'No notifications are setup yet.',
  noNotificationsForEventType: 'No notifications are setup for this event type.',
};

export default NotificationsErrors;
